/**
 * Order bumps exibidos no checkout de contratação.
 * Cada `stripePriceId` deve existir no Stripe como price **recorrente** compatível com o plano
 * (mesmo intervalo de cobrança do checkout) e estar listado em `STRIPE_CHECKOUT_ORDER_BUMP_PRICE_IDS` na API.
 *
 * Configure via `VITE_CHECKOUT_ORDER_BUMPS_JSON` (array JSON). Ex.:
 * `[{"id":"curso-leads","titulo":"Curso Leads","descricao":"...","precoLabel":"R$ 97/mês","stripePriceId":"price_xxx"}]`
 */
export type CheckoutOrderBumpDef = {
  id: string;
  titulo: string;
  descricao: string;
  precoLabel: string;
  stripePriceId: string;
};

export function getCheckoutOrderBumps(): CheckoutOrderBumpDef[] {
  const raw = import.meta.env.VITE_CHECKOUT_ORDER_BUMPS_JSON?.trim();
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (x): x is CheckoutOrderBumpDef =>
          x != null &&
          typeof x === 'object' &&
          typeof (x as CheckoutOrderBumpDef).id === 'string' &&
          typeof (x as CheckoutOrderBumpDef).titulo === 'string' &&
          typeof (x as CheckoutOrderBumpDef).descricao === 'string' &&
          typeof (x as CheckoutOrderBumpDef).precoLabel === 'string' &&
          typeof (x as CheckoutOrderBumpDef).stripePriceId === 'string' &&
          (x as CheckoutOrderBumpDef).stripePriceId.length > 0,
      )
      .slice(0, 10);
  } catch {
    return [];
  }
}
